import PropTypes from 'prop-types'

const sizes = ['small', 'medium', 'large', 'sm', 'md', 'lg']

const sizesProp = PropTypes.oneOf(sizes)
sizesProp.values = sizes

export { sizesProp }
